module.exports = __webpack_public_path__ + "img/replace-icon.fd177057.png";